module.exports = __webpack_public_path__ + "img/2024big17.5a92038e.png";